import { BrowserRouter, Routes, Route } from 'react-router-dom'
import styled, { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'
import UserContext from '../context/UserContext'
import { useState } from 'react'

import Home from './Home'
import InstrucaoCalibragem from './InstrucaoCalibragem'
import Calibragem from './Calibragem'
import ComAnel from './ComAnel'
import InstrucaoSemAnel from './InstrucaoSemAnel'
import SemAnel from './SemAnel'

import wallpaper from '../imgs/wallpaper.jpg'

export default function App() {
  const [tamCartao, setTamCartao] = useState('160')
  const umCm = tamCartao / 5.4

  return (
    <>
      <Img1 src={wallpaper}></Img1>
      <BrowserRouter>
        <GlobalStyled />
        <UserContext.Provider value={{ tamCartao, setTamCartao, umCm }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/instrucao-calibragem"
              element={<InstrucaoCalibragem />}
            />
            <Route path="/calibragem" element={<Calibragem />} />
            <Route path="/medicao-com-anel" element={<ComAnel />} />

            <Route path="/instrucao-sem-anel" element={<InstrucaoSemAnel />} />
            <Route path="/medicao-sem-anel" element={<SemAnel />} />
          </Routes>
        </UserContext.Provider>
      </BrowserRouter>
    </>
  )
}

const GlobalStyled = createGlobalStyle`
    ${reset}
    *, body {
        box-sizing: border-box;
        cursor: default;
        /* font-family: "muli" !important; */
       font-family: 'Montserrat', sans-serif;
        color: #0d47a1;
    a {
        text-decoration: none;
    }
    }
    body {
      background-color: #ffffff;
    }
`

const Img1 = styled.img`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 100vh;
  min-width: 100vw;
  z-index: -1;
  opacity: 0.075;
  /* filter: blur(7px); */

  @media (min-width: 700px) {
    transform: translate(-50%, 0) rotate(0);
    min-height: 100vh;
    width: auto;
    left: 50%;
  }

  @media (min-width: 1300px) {
    height: auto;
    width: 100vw;
  }
`
